import React from "react";

import { splitString } from "./utils";
import TextSegment from "./TextSegment";
import { cn } from "../../../utils/helpers";

const TextParser = ({ value = "", className, variables = {} }) => {
  const segments = splitString(value);

  return (
    <span
      id="markdown"
      className={cn("inline items-center leading-5", className)}
    >
      <TextSegment
        childSegments={segments}
        isRootElement
        variables={variables}
      />
    </span>
  );
};

export default TextParser;
